'use strict';

/**
 * template name
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------
// ----------------------------------------
// Private
// ----------------------------------------

// ----------------------------------------
// Public
// ----------------------------------------
function videoController(slider){
	// let $slider = $(slider),
	// 	$videoList = $slider.find('video');
	//
	// $videoList.each(function (i,el) {
	// 	// el.pause();
	//
	// 	console.log(el)
	// 	el.addEventListener('ended', function () {
	// 		console.log('video Off');
	// 		el.pause();
	// 	}, false);
	//
	// 	$(el).on("startVideo", function() {
	// 		el.start();
	//
	// 	$(el).on("ended", function() {
	// 		alert("Video Finished");
	// 	});
	//
	// });

}
// ----------------------------------------
// Exports
// ----------------------------------------

export default videoController;



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/video.js